import { setData } from '@/utils/server';

/**
 * Save game data to local storage
 * @param {string} boardId - The ID of the current board
 * @param {Object} gameState - The current game state
 */
export function saveBoardToLocalStorage(boardId, gameState) {
  // Get existing user data from localStorage
  const userDataString = localStorage.getItem('userData');
  let userData = {};

  // Parse the JSON string to get the saved data object
  if (userDataString) {
    userData = JSON.parse(userDataString);
  }

  // Check if data for the current boardId already exists
  if (!userData[boardId]) {
    userData[boardId] = {}; // If not, create a new object for the boardId
  }

  // Update the game state in the userData object
  userData[boardId] = {
    guessedCountries: gameState.guessedCountries,
    guesses: gameState.guesses,
    previousGuesses: gameState.previousGuesses,
    isGameOver: gameState.isGameOver,
    board: gameState.board,
    rarityPercentages: gameState.rarityPercentages,
    score: gameState.score,
    wrongGuesses: gameState.wrongGuesses || [],
    infiniteMode: gameState.infiniteMode,
    hasMadeGuessInInfiniteMode: gameState.hasMadeGuessInInfiniteMode,
    archiveMode: gameState.archiveMode,
    rankData: gameState.rankData ?? undefined,
  };

  // Save the updated userData object to localStorage
  localStorage.setItem('userData', JSON.stringify(userData));
  setData('userData', userData);
}

/**
 * Load game data from local storage
 * @param {string} boardId - The ID of the board to load
 * @returns {Object|null} - The loaded game state or null if not found
 */
export function loadBoardFromLocalStorage(boardId) {
  // Check if there is saved data for the boardId in local storage
  const userDataString = localStorage.getItem('userData');
  if (userDataString) {
    // Parse the JSON string to get the saved data object
    const userData = JSON.parse(userDataString);
    if (userData[boardId]) {
      // Return the saved data if it exists
      return userData[boardId];
    }
  }
  return null;
}

/**
 * Delete user data for a specific board from local storage
 * @param {string} boardId - The ID of the board to delete
 */
export function deleteBoardFromLocalStorage(boardId) {
  const userDataString = localStorage.getItem('userData');
  const userLeaderboardDataString = localStorage.getItem('leaderboard_data_' + boardId);

  if (userDataString) {
    const userData = JSON.parse(userDataString);
    if (userData[boardId]) {
      delete userData[boardId];
      localStorage.setItem('userData', JSON.stringify(userData));
    }
  }

  if (userLeaderboardDataString) {
    localStorage.removeItem('leaderboard_data_' + boardId);
  }
}
